import Vue from 'vue'
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import tw from 'vee-validate/dist/locale/zh_TW.json'
import App from './App.vue'
import router from './router'
import Vue2SimpleDatatable from 'vue2-simple-datatable'
import VueFirestore from 'vue-firestore'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/build/css/mdb.css'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
// import 'fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import firebase from 'firebase'
import { rtdbPlugin, firestorePlugin } from 'vuefire'
import '@firebase/firestore'
// import '@babel/polyfill'
// require('babel-polyfill');

localize('zh_TW', tw)

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})
// Install components globally
Vue.use(BootstrapVue)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
Vue.use(VueFirestore)
Vue.use(Vue2SimpleDatatable)
Vue.use(rtdbPlugin, firestorePlugin)
Vue.config.productionTip = false

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyDXgrRqDByp7H8lVffYDYsSyKq9WLB70k0',
  authDomain: 'oa-2021.firebaseapp.com',
  databaseURL: 'https://oa-2021-default-rtdb.firebaseio.com',
  projectId: 'oa-2021',
  storageBucket: 'oa-2021.appspot.com',
  messagingSenderId: '1019465823943',
  appId: '1:1019465823943:web:fc9a853df2218f54e430e2',
  measurementId: 'G-NWKXCXP9CH'

})
// let db = app.database();
export const db = firebaseApp.firestore()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
